import React, { useEffect } from "react";
import { Form, DatePicker, Segmented, Grid } from "antd";
import dayjs from "dayjs";
import log from "cslog";
import styles from "./styles/ContentCalenderForm.module.css";

export default function SocialDateRangePicker({
    dateOption,
    setDateOption,
    dateRange,
    setDateRange,
    form,
}) {
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const isMobile = !screens.sm;

    useEffect(() => {
        if (!form.getFieldValue("dateRange") && dateRange) {
            form.setFieldsValue({ dateRange });
        }
    }, [dateRange, form]);

    const handleDateOptionChange = (value) => {
        setDateOption(value);
        let newDateRange;
        const today = dayjs();
        log.d(value, "now value of days wala");
        switch (value) {
            case "1 day":
                newDateRange = [today, today];
                break;
            case "3 days":
                newDateRange = [today, today.add(2, "days")];
                break;
            case "5 days":
                newDateRange = [today, today.add(4, "days")];
                break;
            case "1 Week":
                newDateRange = [today, today.add(6, "days")];
                break;
            case "2 Weeks":
                newDateRange = [today, today.add(13, "days")];
                break;
            case "1 Month":
                newDateRange = [today, today.add(29, "days")];
                break;
            case "Custom":
                break;
            default:
                newDateRange = [today, today.add(10, "days")];
        }
        log.d(newDateRange, "newDateRangeee");
        if (newDateRange) {
            setDateRange(newDateRange);
            form.setFieldsValue({ dateRange: newDateRange });
        }
    };

    const handleDateChange = (dates) => {
        setDateRange(dates);
        form.setFieldsValue({ dateRange: dates });
    };

    return (
        <Form.Item
            name="dateRange"
            label={<div className={styles.label}>Select Date Range</div>}
            rules={[
                {
                    required: true,
                    message: "Please select a date range",
                },
            ]}
        >
            <div
                style={{
                    marginBottom: 8,
                    marginTop: 8,
                    maxWidth: "100vw",
                    overflowX: "auto",
                }}
            >
                <Segmented
                    options={[
                        { label: "1 day", value: "1 day" },
                        { label: "3 days", value: "3 days" },
                        { label: "5 days", value: "5 days" },
                        { label: "1 Week", value: "1 Week" },
                        { label: "2 Weeks", value: "2 Weeks" },
                        { label: "1 Month", value: "1 Month" },
                        { label: "Custom", value: "Custom" },
                    ]}
                    value={dateOption}
                    onChange={handleDateOptionChange}
                    style={{ marginBottom: 8 }}
                    // block
                />
            </div>

            {!["Custom", "1 day"].includes(dateOption) &&
                dateRange?.length > 1 && (
                    <div
                        style={{
                            color: "rgba(13, 137, 114, 1)",
                            fontWeight: "bold",
                        }}
                    >
                        {dateRange[0].format("DD MMM YYYY")} -{" "}
                        {dateRange[1].format("DD MMM YYYY")}
                    </div>
                )}

            {dateOption === "1 day" && (
                <div
                    style={{
                        color: "rgba(13, 137, 114, 1)",
                        fontWeight: "bold",
                    }}
                >
                    {dayjs().format("DD MMM YYYY")}
                </div>
            )}

            {dateOption === "Custom" && (
                <DatePicker.RangePicker
                    value={dateRange}
                    onChange={handleDateChange}
                    size={isMobile ? "large" : "middle"}
                    style={{ width: isMobile ? "100%" : "50%" }}
                />
            )}
        </Form.Item>
    );
}
